import { useState } from 'react';
import type { FaqItem } from '@/types/content';

export default function FaqAccordion({ items, defaultOpen = 0 }: { items: FaqItem[]; defaultOpen?: number }) {
  const [open, setOpen] = useState<number | null>(defaultOpen);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item, index) => {
        const isOpen = open === index;
        return (
          <div key={item.q}>
            <h3 className="m-0">
              <button
                type="button"
                onClick={() => setOpen(isOpen ? null : index)}
                aria-expanded={isOpen}
                className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100 md:px-6"
              >
                <span className="font-heading text-base font-semibold text-foreground-900">{item.q}</span>
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border transition-colors ${
                    isOpen
                      ? 'border-accent-400 bg-accent-500 text-background-50'
                      : 'border-background-300 text-foreground-600'
                  }`}
                >
                  <i className={isOpen ? 'ri-subtract-line text-sm' : 'ri-add-line text-sm'} aria-hidden="true"></i>
                </span>
              </button>
            </h3>
            {isOpen && (
              <div className="px-5 pb-6 md:px-6">
                <p className="max-w-3xl text-sm leading-relaxed text-foreground-600">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}